// @flow
import React from 'react';
import { Modal } from 'react-bootstrap';
import isNull from 'lodash/isNull';

import I18n from 'PMT/i18n/I18n';

import ViewConstants from 'constants/ViewConstants';

import Button from 'PMT/components/Button';

import OrderDetailView from '../orderDetailModal/OrderDetailView';

export const OrderCancelModal = ({
  order,
  isLoading,
  onHide,
  onSubmit,
  show,
  errorCancel,
  restaurantMenu,
  currencyCode
}) => (
  <Modal bsSize="large" show={show} onHide={onHide}>
    <Modal.Header>
      <button type="button" className="close close-white" onClick={onHide}>
        <span aria-hidden="true">×</span>
      </button>

      <Modal.Title>{I18n.tr('components.order.cancel.title')}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {isLoading && (
        <div className="page_loading_show">
          <div className="page_loading_show__gif">
            <img src={ViewConstants.Image.LOADING_BAR} role="presentation" />
          </div>
        </div>
      )}
      {!isNull(errorCancel) && (
        <p className="alert alert-danger">
          {!_.isNil(errorCancel) && !_.isNil(errorCancel.localizedMessage)
            ? errorCancel.localizedMessage
            : I18n.tr('components.order.cancel.error')}
        </p>
      )}
      <OrderDetailView order={order} onHide={onHide}
                       restaurantMenu={restaurantMenu}
                       currencyCode={currencyCode}/>
      <p className="top-buffer-50">{I18n.tr('components.order.cancel.verifyCancel')}</p>
      {order.isPayed() && (
        <p style={{ color: '#ffc107', whiteSpace: 'pre-line' }}>
          {order.irlPayment
            ? I18n.tr('components.order.cancel.noRefundCancel')
            : I18n.tr('components.order.cancel.refundCancel')}
        </p>
      )}
    </Modal.Body>
    <Modal.Footer>
      <Button className="btn btn-default" onClick={onHide}>
        {I18n.tr('components.order.cancel.close')}
      </Button>
      <Button className="btn btn-primary" onClick={onSubmit} disabled={!isNull(errorCancel)}>
        {I18n.tr('components.order.cancel.submit')}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default OrderCancelModal;



// WEBPACK FOOTER //
// ./scripts/components/order/orderCancelModal/OrderCancelModal.js